<template>
  <div class="container">
    <top-menu></top-menu>

    <div class="main-container">
      <div class="m-ad">
        <img :src="series.cover_url" alt="" />
      </div>
      <div class="car-info-box">
        <div class="car-info">
          <div class="car-inner">
            <h4 class="car-name">{{ series.name }}</h4>
          </div>
        </div>

        <div class="summary-series__guide">
          厂商指导价：<strong>{{ series.price }}</strong>
        </div>
      </div>
      <a-row type="flex" justify="center" class="summary-series__nav">
        <a-col
          :span="8"
          class="summary-series__nav-item"
          v-for="(item, i) in navList"
          :key="item.name"
          :style="item.checked ? 'transform: scale(1.2);' : ''"
          @click="toggleNav(i)"
        >
          {{ item.name }}
        </a-col>
      </a-row>

      <!-- 车型列表 -->
      <div class="summary-series__models" v-if="navList[0].checked">
        <div class="summary-typelist" v-for="item in models" :key="item.year">
          <div class="summary-typelist__year">{{ item.year }}</div>
          <div v-for="list in item.list" :key="list.group_name">
            <div class="summary-typelist__category">
              {{ list.group_name }}
            </div>
            <ul>
              <li v-for="model in list.list" :key="model.id">
                <a liaspec="" href="javascript:void(0)">
                  <div class="summary-typelist__caption">
                    {{ model.name }}
                  </div>
                  <div class="summary-typelist__price">
                    <span><strong>35.62</strong>万起</span>
                  </div>

                  <div class="summary-typelist__guide" data-guide="419800">
                    {{ model.guide_price
                    }}<strong class="rangedown"
                      ><svg class="iconsvg">
                        <use xlink:href="#iconsvg-trendbottom"></use></svg
                      >6.36万</strong
                    >
                  </div>
                </a>

                <div class="summary-typelist__handle">
                  <router-link :to="{ name: 'Quote', query: { bname: series.brand.name, sname: series.name } }" class="athm-btn athm-btn--bright">
                  <span>获取底价</span>
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 图片 -->
      <div class="summary-series__images" v-if="navList[1].checked">
        <a-row v-for="item in modelImages" :key="item.classify">
          <a-col>
            <div
              class="summary-series__images-title"
              v-if="item.classify === 1"
            >
              外观
            </div>
            <div
              class="summary-series__images-title"
              v-if="item.classify === 2"
            >
              中控
            </div>
            <div
              class="summary-series__images-title"
              v-if="item.classify === 3"
            >
              座椅
            </div>
            <div
              class="summary-series__images-title"
              v-if="item.classify === 4"
            >
              细节
            </div>
            <lightbox
              :items="item.images"
              css="summary-series__images-box"
            ></lightbox>
          </a-col>
        </a-row>
      </div>

      <div class="summary-series__news" v-if="navList[2].checked">
        <div
          class="summary-series__news-card"
          v-for="item in news"
          :key="item.id"
        >
          <router-link :to="{ name: 'Article', params: { id: item.id } }" class="summary-series__news-card-a">
            <div class="summary-series__news-image">
              <img :src="item.img_url" />
            </div>
            <div class="summary-series__news-caption">
              {{ item.title }}
            </div>
            <div class="summary-series__news-information">
              <div class="summary-series__news-information__assist">
                <span class="athm-card-unit-information__item">{{
                  item.published_at
                }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import Footer from "@/components/Footer";
import {
  getSeriesById,
  getSeriesImagesById,
  getSeriesNewsById,
} from "@/api/car";

export default {
  name: "Index",
  components: {
    TopMenu,
    Footer,
  },
  data() {
    return {
      id: 0,
      navList: [
        {
          name: "车型列表",
          checked: true,
          load: true,
        },
        {
          name: "图片",
          checked: false,
          load: false,
        },
        {
          name: "资讯",
          checked: false,
          load: false,
        },
      ],
      series: {
        name: "",
        price: "",
        cover_url: "",
        brand: {
          name: ''
        }
      },
      models: [],
      modelImages: [],
      news: [],
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.id = this.$route.params.id;
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    getData() {
      getSeriesById(this.id).then((response) => {
        console.log(response);
        this.series = response.data;
        this.models = response.data.models;
      });
    },
    getSeriesImages() {
      getSeriesImagesById(this.id).then((resp) => {
        this.modelImages = resp.data;
      });
    },
    getSeriesNews() {
      getSeriesNewsById(this.id).then((resp) => {
        this.news = resp.data;
      });
    },
    toggleNav(i) {
      var that = this;
      this.navList.forEach((item, key) => {
        if (i == key) {
          item.checked = true;

          if (!item.load) {
            item.load = true;
            if (i == 1) {
              that.getSeriesImages();
            }
            if (i == 2) {
              that.getSeriesNews();
            }
          }
        } else {
          item.checked = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
   position: relative;
  top:100px;
  .m-ad {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }

  .idx-title-nav {
    margin: 1rem 0;
  }

  .car-info-box {
    padding: 0.373333rem 0.533333rem 0.32rem;
    background: #fff;
    position: relative;
    .car-info {
      .car-inner {
        display: block;
        width: 100%;
        position: relative;
        .car-name {
          margin: 0 3px 0 0;
          font-size: 26px;
          font-weight: 700;
          color: #111e36;
        }
      }
    }
    .summary-series__guide {
      //   margin: 20px 0;
      font-size: 12px;
      font-weight: 300;
      color: #111e36;
      strong {
        font-family: DINAlternate-Bold;
        font-size: 18px;
        color: #f60;
      }
    }
  }
}

.summary-series__nav {
  text-align: center;
  background-color: #ffffff;
  margin-top: 10px;
  padding: 15px 0px;
  .summary-series__nav-item {
    font-size: 16px;
    font-weight: 600;
  }
}

.summary-typelist__year {
  padding: 0 20px;
  font-size: 14px;
  font-weight: 700;
  color: #111e36;
  line-height: 40px;
  background-color: #ffffff;
}
.summary-typelist__category {
  padding: 0 20px;
  font-size: 12px;
  font-weight: 300;
  color: #666d7f;
  line-height: 30px;
  background-image: linear-gradient(90deg, #f8f9fc, #fff);
}

.summary-typelist {
  ul {
    margin-bottom: 0;
  }
  li {
    position: relative;
    display: block;
    padding: 14px 20px 30px;
    overflow: hidden;
    background-color: #ffffff;
    .summary-typelist__caption {
      padding-right: 110px;
      font-size: 16px;
      font-weight: 400;
      color: #111e36;
      line-height: 20px;
    }
    .summary-typelist__price {
      position: absolute;
      top: 13px;
      right: 20px;
      font-size: 14px;
      color: #f60;
    }
    .summary-typelist__guide {
      height: 12px;
      margin-top: 25px;
      font-size: 12px;
      color: #666d7f;
    }
    .summary-typelist__handle {
      position: absolute;
      right: 15px;
      bottom: 25px;
      .athm-btn {
        border: 0;
        outline: 0;
        // width: 58px;
        // height: 28px;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        color: var(--fifthly-color, #fff);
        background: #e42a2a;
        background: var(--secondary-color, #e42a2a);
        padding: 10px;
      }
    }
  }
}

.summary-series__images {
  width: 100%;
  .summary-series__images-title {
    padding: 0 20px;
    font-size: 14px;
    font-weight: 300;
    line-height: 35px;
    font-weight: 600;
    background-image: linear-gradient(90deg, #f8f9fc, #fff);
  }
  .summary-series__images-box {
    height: 300px;
  }
}

.summary-series__news {
  width: 100%;
  background-color: #ffffff;
  .summary-series__news-card {
    line-height: 1;
    overflow: hidden;
    .summary-series__news-card-a {
      position: relative;
      display: block;
      padding: 12px 26px 12px 20px;
      overflow: hidden;
    }
    .summary-series__news-image {
      position: relative;
      float: right;
      width: 33.333%;
      margin: 0 -6px 0 12px;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        -o-object-fit: cover;
        object-fit: cover;
        pointer-events: none;
      }
    }
    .summary-series__news-caption {
      max-height: 48px;
      font-size: 16px;
      color: #111e36;
      line-height: 24px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .summary-series__news-information {
      position: absolute;
      bottom: 18px;
      left: 20px;
      width: calc(66.666% - 36.666px);
      .summary-series__news-information__assist {
        position: relative;
        font-size: 1px;
        color: #666d7f;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>

